import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.projects');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const PROJECT_WORKFLOW_ID_KEY = 'actuator:lastProjectId';

@Component({
    standalone: false,
    selector: 'wiz-page-projects',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.projects/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageProjectsComponent implements OnInit {
    public items: any[] = [];
    public loading: boolean = true;
    public error: string = '';
    public search: any = { text: '', status: '', partType: '' };
    public selectedStage: string = 'design';
    public workflowTabs: any[] = [
        { key: 'design', label: '설계' },
        { key: 'documents', label: '문서' },
        { key: 'simulation', label: '시뮬레이션' },
        { key: 'digital_twin', label: '디지털 트윈' },
        { key: 'review', label: '검토' },
        { key: 'reports', label: '리포트' }
    ];
    public partTypes: string[] = ['전체', '파워 트렁크', '전동 도어', '전동 시트', '에어로 파츠', '사이드 스텝', '선루프'];
    public statuses: any[] = [
        { value: '', label: '전체' },
        { value: 'draft', label: '초안' },
        { value: 'in_progress', label: '진행중' },
        { value: 'completed', label: '완료' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.syncStageFromUrl();
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.error = '';
        await this.service.render();
        try {
            const res = await wiz.call("list", this.search);
            const code = res ? res.code : -1;
            const data = res ? res.data : null;
            if (code === 200) {
                const payload = (data && data.data) || data || {};
                this.items = (payload && payload.items) || [];
            } else {
                this.items = [];
                this.error = typeof data === 'string' ? data : ((data && data.message) || '프로젝트 목록을 불러오지 못했습니다.');
            }
        } catch (error: any) {
            this.items = [];
            this.error = (error && error.message) || '프로젝트 목록을 불러오는 중 오류가 발생했습니다.';
            console.error('[projects/list]', error);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async filterByStatus(status: string) {
        this.search.status = status;
        await this.load();
    }

    public async filterByPart(part: string) {
        this.search.partType = part === '전체' ? '' : part;
        await this.load();
    }

    public async onSearch() {
        await this.load();
    }

    public getStatusClass(status: string) {
        const m: any = { draft: 'bg-yellow-50 text-yellow-700 border border-yellow-200', in_progress: 'bg-blue-50 text-blue-700 border border-blue-200', completed: 'bg-green-50 text-green-700 border border-green-200' };
        return m[status] || 'bg-gray-50 text-gray-600 border border-gray-200';
    }

    public getStatusLabel(status: string) {
        const m: any = { draft: '초안', in_progress: '진행중', completed: '완료' };
        return m[status] || status;
    }

    private isWorkflowStage(stage: string) {
        return this.workflowTabs.some((tab: any) => tab.key === stage);
    }

    private syncStageFromUrl() {
        const params = new URLSearchParams(location.search);
        const stage = params.get('stage') || params.get('tab') || '';
        if (this.isWorkflowStage(stage)) this.selectedStage = stage;
    }

    private rememberProjectId(id: string) {
        if (!id) return;
        try {
            localStorage.setItem(PROJECT_WORKFLOW_ID_KEY, id);
        } catch (e) {}
    }

    public selectStage(stage: string) {
        if (!this.isWorkflowStage(stage)) return;
        this.selectedStage = stage;
        this.service.href(`/projects?stage=${stage}`);
    }

    public stageClass(stage: string) {
        if (this.selectedStage === stage) {
            return 'border-slate-950 bg-slate-950 text-white shadow-sm';
        }
        return 'border-slate-200 bg-white text-slate-600 hover:border-cyan-300 hover:text-slate-950 dark:border-white/10 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-white/5 dark:hover:text-white';
    }

    public stageIndex(stage: string) {
        const index = this.workflowTabs.findIndex((tab: any) => tab.key === stage);
        return index >= 0 ? String(index + 1).padStart(2, '0') : '00';
    }

    public openProject(item: any) {
        if (!item || !item.id) return;
        this.rememberProjectId(item.id);
        this.service.href(`/projects/${item.id}/${this.selectedStage}`);
    }

    public openProjectTab(item: any, tab: string, event?: any) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (!item || !item.id) return;
        this.rememberProjectId(item.id);
        this.service.href(`/projects/${item.id}/${tab}`);
    }
}

export default PageProjectsComponent;